export const ALL_MY_SURVEYS = 'ALL_MY_SURVEYS';
